

class ComicList {
  constructor(comics) {
    this.comics = comics;
    this.hasComics = comics && comics.length > 0;

    this.charFirstComic = {};
    this.charLastComic = {};

    if (!this.hasComics) return;

    // Add the number to each comic, so that it's there even if the list is filtered.
    this.comics = this.comics.map((comic, index) => ({
      ...comic,
      number: index + 1
    }));

    this.lastComicChar = comics[comics.length - 1].chars[0];

    for (let i = 0; i < comics.length; i++) {
      comics[i].chars.forEach(char => {
        this.charFirstComic[char] = Math.min(this.charFirstComic[char] || comics.length, i + 1);
        this.charLastComic[char] = Math.max(this.charLastComic[char] || 0, i + 1);
      });
    }
  }

  comicFilename(comic, char) {
    if (!this.hasComics) return '';
    comic = this.validComicNumber(comic, char);
    if (!this.comics[comic - 1]) return '';
    const chars = this.comics[comic - 1].chars;
    const charsSuffix = chars.length ? '_' + chars.join('_') : '';
    return comic + charsSuffix + '.png';
  }

  firstComic(char) {
    if (!this.hasComics || !char) return 1;
    return this.charFirstComic[this.validChar(char)] || 1;
  }

  lastComic(char) {
    if (!this.hasComics) return 1;
    if (!char) return this.comics.length;
    return this.charLastComic[this.validChar(char)] || this.comics.length;
  }

  prevComic(comic, char) {
    if (!this.hasComics) return 1;

    char = this.validChar(char);
    comic = this.validComicNumber(comic, char);

    const minComic = char ? this.charFirstComic[char] : 1;
    if (comic <= minComic) return minComic;
    do {
      comic--;
    } while (char && comic > minComic && !this.hasChar(comic, char));
    return comic;
  }

  nextComic(comic, char) {
    if (!this.hasComics) return 1;

    char = this.validChar(char);
    comic = this.validComicNumber(comic, char);

    const maxComic = char ? this.charLastComic[char] : this.comics.length;
    if (comic >= maxComic) return maxComic;
    do {
      comic++;
    } while (char && comic < maxComic && !this.hasChar(comic, char));
    return comic;
  }

  allComics(char) {
    char = this.validChar(char);
    if (!char) {
      return this.comics;
    }
    return this.comics.filter(comic => comic.chars.indexOf(char) !== -1);
  }

  hasChar(comic, char) {
    return this.comics[comic - 1].chars.indexOf(char) !== -1;
  }

  validChar(char) {
    if (typeof(char) !== 'string') return '';
    const formatted = char.charAt(0).toUpperCase() + char.slice(1).toLowerCase();
    if (!this.charFirstComic[formatted]) return '';
    return formatted;
  }

  validComicNumber(comic, char) {
    if (comic === 'latest') return this.lastComic(char);
    const numericComic = Math.floor(comic);
    return Math.min(this.lastComic(char), Math.max(this.firstComic(char), numericComic));
  }
}

export default ComicList;
